

























































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component, Prop, PropSync, Watch} from "vue-property-decorator";
import {ComplaintCustomerStore} from "../store";
import {LadingStatus} from "@/enums/status";
import {LadingPaymentType} from "@/enums/type";
import {Complaint} from "@/interfaces/entity";
import {LadingCustomerStatus} from "@/enums/status/ladingcustomerstatus";
@Component({
    name: "ComplaintCustomerDetail"
})
export default class extends mixins(CommonMixin) {
    @Prop() id!: number;
    @PropSync('visibleDetail') visibleDetailSync!: boolean;
    complaintCustomer: Complaint = null as any;
    LadingStatus = LadingStatus;
    LadingPaymentType = LadingPaymentType;
    LadingCustomerStatus = LadingCustomerStatus;

    @Watch('id', { immediate: true })
    onChangeId(val: any) {
        console.log(val);
        if (this.id) {
            this.singleComplaintCustomer(val);
        }
    }

    async singleComplaintCustomer(id: number) {
        try {
            this.complaintCustomer = await ComplaintCustomerStore.singleComplaintCustomer(id);
        } catch (e) {
            this.$message.error(e?.respose?.data?.message || "Đã xảy ra lỗi");
        }
    }
}
